import { type ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

import { GuaranteeListSkeleton } from './components/guarantee-list/guarantee-list-skeleton.tsx'

/**
 * Pending state for `ProductGuaranteesPage`. Reuses the same `View` / `Section` / card frame as the
 * loaded page — product title, then the activity heading over the company address, then the grouped
 * guarantee list — so the crossfade has no layout shift.
 */
export function ProductGuaranteesPageSkeleton(): ReactElement {
  const translate = useTranslate()

  return (
    <LoadingRegion label={translate('loading_aria_label')} className="min-h-full">
      <View.Root>
        <View.Header>
          <Skeleton variant="text" width={260} height={32} />
        </View.Header>
        <View.Body>
          <Section.Root>
            <Section.Header>
              <Skeleton variant="text" width={200} height={24} className="col-start-1" />
              <Skeleton variant="text" width={280} height={20} className="col-start-1" />
            </Section.Header>
            <Section.Body>
              <GuaranteeListSkeleton />
            </Section.Body>
          </Section.Root>
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
